import i18n from "i18n";
import * as Yup from "yup";

export interface RenameGroupFormFields {
  name: string;
}

export const buildRenameGroupFormSchema = (): Yup.SchemaOf<RenameGroupFormFields> =>
  Yup.object({
    name: Yup.string().required(
      i18n.t("groups:groupDetails.renameGroupModal.fields.name.errors.required"),
    ),
  }).required();
